import Vue from 'vue'

import { list, show, edit, create, remove } from './splitServices'

const state = {
  splitConfiguration: {},
  splitConfigurations: [],
  isSplitConfigurationLoading: false,
}

const getters = {
  splitConfiguration: (state) => state.splitConfiguration,
  splitConfigurations: (state) => state.splitConfigurations,
  isSplitConfigurationLoading: (state) => state.isSplitConfigurationLoading,
}

const actions = {
  async fetchSplitConfiguration({ commit, dispatch }, id) {
    commit('setIsSplitConfigurationLoading', true)

    try {
      const { data } = await show(id)
      commit('setSplitConfiguration', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsSplitConfigurationLoading', false)
    }
  },

  async fetchSplitConfigurations({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await list(params)
      const { result, total } = data

      commit('setSplitConfigurations', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async createEditSplitConfiguration({ commit, dispatch }, splitConfiguration) {
    commit('setIsSplitConfigurationLoading', true)

    try {
      await create(splitConfiguration)
      commit('closeAllModals')
      commit('setSplitConfiguration', null)
      dispatch('fetchSplitConfigurations')
      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate('split.messages.successfullyCreated')
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsSplitConfigurationLoading', false)
    }
  },

  async removeSplitConfiguration({ commit, dispatch }, id) {
    commit('setIsSplitConfigurationLoading', true)

    try {
      await remove(id)

      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate('split.messages.successfullyDeleted')
      )
      dispatch('fetchSplitConfigurations')
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsSplitConfigurationLoading', false)
    }
  },

  handleOpenCreateEditSplitConfigurationModal({ dispatch, commit }, id) {
    commit('setSplitConfiguration', null)
    dispatch('openModal', 'CREATE_EDIT_SPLIT_CONFIGURATION_MODAL')
    id && dispatch('fetchSplitConfiguration', id)
  },

  handleDeleteSplitConfigurationItemModal({ dispatch, commit }, id) {
    commit('setSplitConfiguration', {})
    dispatch('openModal', 'DELETE_SPLIT_CONFIGURATION_MODAL')
    id && dispatch('fetchSplitConfiguration', id)
  },
}

const mutations = {
  setSplitConfiguration: (state, splitConfiguration) => {
    state.splitConfiguration = splitConfiguration
  },

  setSplitConfigurations: (state, splitConfigurations) => {
    state.splitConfigurations = splitConfigurations
  },

  setIsSplitConfigurationLoading: (state, status) => {
    state.isSplitConfigurationLoading = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
